/* eslint-disable */

export const lifeCycleTimeLine = {
    LIFE_CYCLE_TIME_LINE_REQUEST: 'LIFE_CYCLE_TIME_LINE_REQUEST',
    LIFE_CYCLE_TIME_LINE_SUCCESS: 'LIFE_CYCLE_TIME_LINE_SUCCESS',
    LIFE_CYCLE_TIME_LINE_FAILURE: 'LIFE_CYCLE_TIME_LINE_FAILURE',
};
